import { NavLink } from 'react-router-dom';
import { MoreHorizontal } from 'lucide-react';
import { MOBILE_TABS } from '@/lib/routes';
import { cn } from '@/lib/cn';

// Mobile-only bottom tab bar. Hidden at lg+. Includes iOS safe-area padding.
// Shows 4 primary tabs + 1 "More" that opens the full nav drawer.
export function TabBar() {
  return (
    <nav
      className={cn(
        'lg:hidden fixed bottom-0 inset-x-0 z-40',
        'h-[84px] grid grid-cols-5 gap-1 px-2 pt-2',
        'bg-[rgba(20,20,24,0.85)] backdrop-blur-xl',
        'border-t border-[color:var(--border)]',
      )}
      style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 12px)' }}
    >
      {MOBILE_TABS.map((r) => (
        <NavLink
          key={r.path}
          to={r.path}
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center justify-center gap-0.5 rounded-[10px] text-[10px] font-semibold transition-colors',
              isActive ? 'text-text' : 'text-text-faint',
            )
          }
        >
          {({ isActive }) => (
            <>
              <r.icon size={20} strokeWidth={2} className={isActive ? 'text-kam-cyan' : ''} />
              <span>{r.label.split(' ')[0]}</span>
            </>
          )}
        </NavLink>
      ))}
      <NavLink
        to="/more"
        className={({ isActive }) =>
          cn(
            'flex flex-col items-center justify-center gap-0.5 rounded-[10px] text-[10px] font-semibold transition-colors',
            isActive ? 'text-text' : 'text-text-faint',
          )
        }
      >
        <MoreHorizontal size={20} strokeWidth={2} />
        <span>More</span>
      </NavLink>
    </nav>
  );
}
